Cureus.SubmitRereview = {}

//= require_tree ./SubmitRereview
